(function () {
  "use strict";

  const initCollection = () => {
    if (typeof Collection !== "undefined") {
      if (!MinimogTheme.Collection || !MinimogTheme.Collection.initialized) {
        MinimogTheme.Collection = new Collection();
        MinimogTheme.Collection.init();
        MinimogTheme.Collection.initialized = true;
      }
    }
  };

  window.addEventListener("load", initCollection);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      if (MinimogTheme.Collection) {
        MinimogTheme.Collection.initialized = false;
      }
      initCollection();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    const filterButtons = document.querySelectorAll(".type-filter");
    const activeFilterSpan = document.querySelector("#ActiveFilterTitle");

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        filterButtons.forEach((btn) => btn.classList.remove("active"));
        button.classList.add("active");

        const filter = button.dataset.filter || "";
        const filterText = button.nextElementSibling?.textContent?.trim() || "";

        if (activeFilterSpan) {
          activeFilterSpan.textContent = filter ? `› ${filterText}` : "";
        }

        const url = filter
          ? `${window.location.pathname}?constraint=${encodeURIComponent(
              filter
            )}`
          : window.location.pathname;

        fetch(url)
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newWrapper = doc.querySelector("#CollectionWrapper");
            const oldWrapper = document.querySelector("#CollectionWrapper");

            if (newWrapper && oldWrapper) {
              oldWrapper.innerHTML = newWrapper.innerHTML;
              history.replaceState(null, "", url);
              initCollection();

              if (activeFilterSpan) {
                activeFilterSpan.textContent = filter ? `>  ${filterText}` : "";
              }
            }
          })
          .catch((error) => {
            console.error("Error loading collection:", error);
          });
      });
    });
  });
})();
